//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AssignmentsService from '@/apps/data-platform/services/tables_views/assignments_service';
import FilesService from '@/apps/data-platform/services/security/files_service';
import ListTableMetadataCols from '@/apps/data-platform/components/ListTableMetadataColsComponent.vue';
import { DEFAULT_TPL_COLUMNS, DEFAULT_TPL_FIELDS, ACCESS_TYPE_FLOW, TYPE_CHANGE_METADA, ACCES_REQUEST_FILE_FORMAT } from '@/js/constants';
import tasks from '@/js/tasks';
import utils from '@/js/utils';
export default {
  name: 'FormAccessRequest',
  components: {
    ListTableMetadataCols: ListTableMetadataCols
  },
  props: {
    tplToWork: {
      type: Object,
      required: true
    },
    isAudience: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      ACCESS_TYPE_FLOW: ACCESS_TYPE_FLOW,
      TYPE_FLOW: ACCESS_TYPE_FLOW.ACCESS,
      DEFAULT_TPL_COLUMNS: DEFAULT_TPL_COLUMNS,
      DEFAULT_TPL_FIELDS: DEFAULT_TPL_FIELDS,
      TYPE_CHANGE_METADA: TYPE_CHANGE_METADA,
      ACCES_REQUEST_FILE_FORMAT: ACCES_REQUEST_FILE_FORMAT,
      defaultFields: null,
      columnFields: [],
      // response from Api
      columnFieldsLabels: [{
        key: 'column',
        sortable: true,
        stickyColumn: true,
        isRowHeader: true
      }, {
        label: 'Description',
        key: 'templateDisplayName',
        stickyColumn: true,
        isRowHeader: true
      }, {
        label: 'Required',
        key: 'include_in_flow'
      }],
      filter: null,
      filterOn: [],
      toSave: {},
      deployMessage: false,
      message: '',
      files: [],
      isLoading: false,
      isExternalUser: false,
      isServiceAccount: false,
      isDigitalAudience: false,
      externalUserType: null,
      externalUserOptions: [{
        value: 1,
        text: 'External User'
      }, {
        value: 2,
        text: 'Service Account'
      }, {
        value: 3,
        text: 'Digital Audience'
      }, {
        value: 4,
        text: 'Attributes'
      }],
      benefited: '',
      businessCase: '',
      dismissCountDown: 0,
      dismissSecs: 5,
      inputUploadFile: null
    };
  },
  computed: {
    isAccessServiceAccountInput: function isAccessServiceAccountInput() {
      // return ACCESS_SERVICE_ACCOUNT_INPUT.some(record => utils.hasRole(record))
      return true;
    }
  },
  created: function created() {
    var _this = this;
    // Separe defaultTemplate and Columnfields
    var separeValues = tasks.filterDefaultTableTagsAndColumnFields(this.tplToWork.objects.tags);
    this.defaultFields = separeValues.defaultFields;
    this.columnFields = separeValues.columnFields;

    // SET CHECKED DEFAULT COLUMNS
    this.columnFields.map(function (item) {
      var sensitiveField = item.fields[_this.DEFAULT_TPL_COLUMNS.SENSITIVE.name];
      var valueSencible = sensitiveField[_this.DEFAULT_TPL_COLUMNS.SENSITIVE.type];
      if (!valueSencible) {
        sensitiveField.include_in_flow = _this.ACCESS_TYPE_FLOW.INCLUDED;
      }
    });
    this.isExternalUser = this.tplToWork.item.isExternalUser || false;
    this.isServiceAccount = this.tplToWork.item.isServiceAccount || false;
    this.benefited = this.tplToWork.item.benefited || '';
    this.businessCase = this.tplToWork.item.business_case || '';

    // set save to send object
    this.toSave.applicant = window.userInfo.email;
    this.toSave.fields = this.tplToWork.objects.tags; // tags
    this.toSave.owner = this.defaultFields ? this.defaultFields[this.DEFAULT_TPL_FIELDS.OPERATOR.name].stringValue.toLowerCase() : null;
    this.toSave.relativeResourceName = this.tplToWork.item.relativeResourceName;
    this.toSave.table_id = this.tplToWork.item.tableReference.tableId;
    this.toSave.type_flow = this.TYPE_FLOW;
    this.toSave.tableReference = this.tplToWork.item.tableReference;
    this.toSave.endDate = this.tplToWork.endDate && utils.dateBrowserToService(this.tplToWork.endDate);
    this.toSave.index_node = this.tplToWork.item.index_node != null && this.tplToWork.item.index_node >= 0 ? this.tplToWork.item.index_node : -1;
    this.toSave.domain_table = this.tplToWork.item.domain_table;
    this.toSave.benefited = this.benefited;
    this.toSave.commentary = this.tplToWork.item.last_version && this.tplToWork.item.last_version.commentary ? this.tplToWork.item.last_version.commentary : '';
    this.toSave.isExternalUser = this.isExternalUser;
    this.toSave.isServiceAccount = this.isServiceAccount;
    if (this.isAudience) {
      this.isExternalUser = true;
      this.externalUserType = 3;
    }
  },
  methods: {
    onChangeExternalUser: function onChangeExternalUser() {
      this.isServiceAccount = false;
      this.benefited = '';
      this.businessCase = '';
    },
    openImage: function openImage(url) {
      var uriObj = {
        name: 'DisplayImage',
        query: {
          uris: url
        }
      };
      var urlNew = this.$router.resolve(uriObj);
      window.open(urlNew.href, '_blank');
    },
    onSubmit: function onSubmit(event) {
      var _this2 = this;
      event.preventDefault();
      var objectToRequest = this.toSave;
      var contador = 0;
      this.columnFields.map(function (item) {
        var sensitiveField = item.fields[_this2.DEFAULT_TPL_COLUMNS.SENSITIVE.name];
        if (sensitiveField.include_in_flow && sensitiveField.include_in_flow === _this2.ACCESS_TYPE_FLOW.INCLUDED) {
          contador = contador + 1;
        }
      });
      var extraParams = {
        files: this.files,
        isExternalUser: this.isExternalUser,
        isServiceAccount: this.externalUserType == 2 ? true : false,
        isDigitalAudience: this.externalUserType == 3 ? true : false,
        benefited: this.benefited,
        businessCase: this.businessCase
      };
      var params = {
        operator: objectToRequest.owner,
        type_flow: objectToRequest.type_flow,
        table_id: objectToRequest.table_id,
        relativeResourceName: objectToRequest.relativeResourceName,
        commentary: objectToRequest.commentary,
        fields: objectToRequest.fields,
        tableReference: objectToRequest.tableReference,
        endDate: objectToRequest.endDate,
        applicant: objectToRequest.applicant,
        extraParams: extraParams,
        index_node: objectToRequest.index_node,
        domain_table: objectToRequest.domain_table
      };
      if (this.isExternalUser === true) {
        if (extraParams.files.length === 0) {
          tasks.toast.error('If you want, register an external user. You must upload a file to the request');
          //this.$toast.warning('If you want, register an external user. You must upload a file to the request')
          return;
        }
      }
      if (contador > 0) {
        AssignmentsService.initApprovalFlow(params).then(function (response) {
          if (response.code === 200) {
            if (!response.success) {
              _this2.deployMessage = true;
              _this2.message = response.message;
            } else {
              // close all modals
              tasks.toast.success("Successful request!");
              //this.$toast.success("Successful request!")
              _this2.$emit('submit', _this2.toSave);
              //this.$toast.success("Successful request!")
            }
          }
        }).catch(function (e) {
          // hide modal show alert and reload page
          utils.printError(e);
          //this.onSubmit(event)
        });
      } else {
        tasks.toast.error('You must choose at least one row from the required column.');
        //this.$toast.warning('You must choose at least one row from the required column.')
      }
    },
    onCancel: function onCancel(event) {
      event.preventDefault();
      this.$emit('cancel', null);
    },
    onFileChange: function onFileChange(event) {
      var file = event.target.files[0];
      var fileReader = new FileReader();
      var self = this;
      if (!file || file === undefined) {
        return;
      }
      self.isLoading = true;
      fileReader.onload = function (e) {
        var data = {
          content: e.target.result,
          filename: file.name
        };
        self.dismissCountDown = 0;
        FilesService.uploadFile(data).then(function (res) {
          if (res['success']) {
            var _file = {
              fileLink: res['data'] && res['data']['public_url'] || '',
              fileId: res['data'] && res['data']['file_id'] || '',
              fileName: res['data'] && res['data']['filename'] || ''
            };
            self.files.push(_file);
          } else {
            self.dismissCountDown = self.dismissSecs;
            tasks.toast.error(res['message']);
            //alert(res['message'])
          }
          self.isLoading = false;
          self.inputUploadFile = null;
        }).catch(function () {
          self.isLoading = false;
          self.dismissCountDown = self.dismissSecs;
          self.inputUploadFile = null;
        });
      };
      fileReader.readAsDataURL(file);
    },
    deleteFile: function deleteFile(record) {
      var _this3 = this;
      this.isLoading = true;
      if (record.fileId) {
        FilesService.deleteFile(record).then(function (res) {
          // if (res['success']) {
          //   const files = this.files
          //   this.files = files.filter(file => file.fileId !== record.fileId)
          //   this.isLoading = false
          // } else {
          //   alert(res['message'])
          // }
          var files = _this3.files;
          _this3.files = files.filter(function (file) {
            return file.fileId !== record.fileId;
          });
          _this3.isLoading = false;
        });
      }
    },
    countDownChanged: function countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    }
  },
  watch: {
    isExternalUser: function isExternalUser(val) {
      this.isExternalUser = val;
      this.toSave.isExternalUser = val;
    },
    isServiceAccount: function isServiceAccount(val) {
      this.isServiceAccount = val;
      this.toSave.isServiceAccount = val;
    }
  }
};